export const API_URL = process.env.REACT_APP_API_URL;

export const ROWS_PER_PAGE = ['5', '10', '20'];
